import { Tab, Tabs } from "@mui/material";
import { useUnitListStore } from "./useUnitListStore";
import { UnitStatusFilters } from "@safelease/service-utilities";
import { mixpanelEventHandler } from "../../utilities/reactMixpanelHandler";
import { useAuth } from "../../auth";

type StatusTabsProps = {};

function StatusTabs({}: StatusTabsProps) {
  const auth = useAuth();
  const { selectedTab, setSelectedTab, selectedRelationshipId, selectedLocationId } = useUnitListStore((state) => ({
    selectedTab: state.selectedTab,
    setSelectedTab: state.setSelectedTab,
    selectedRelationshipId: state.selectedRelationshipId,
    selectedLocationId: state.selectedLocationId,
  }));

  return (
    <Tabs
      value={selectedTab}
      onChange={(_, newValue) => {
        setSelectedTab(newValue);
        mixpanelEventHandler("Units - Tab Selected", {
          userEmail: auth.user?.email,
          userId: auth.user?.id,
          relationshipId: selectedRelationshipId,
          locationId: selectedLocationId?.toString(),
          selectedTab: newValue,
        });
      }}
      sx={{
        ".MuiTabs-indicator": {
          backgroundColor: "#2779FB", // Custom color for the indicator
        },
        "& .MuiTab-root": {
          // Style for all tabs
          color: "#666666", // Color for unselected tabs
          fontSize: 14,
          fontWeight: 600,
          textTransform: "none",
          "&.Mui-selected": {
            // Style for the selected tab
            color: "#2779FB", // Color for selected tab
          },
        },
      }}
    >
      <Tab value={UnitStatusFilters.ALL} label="All occupied" />
      <Tab value={UnitStatusFilters.SAFELEASE} label="SafeLease" />
      <Tab value={UnitStatusFilters.ELIGIBLE} label="Eligible" />
      <Tab value={UnitStatusFilters.OPTED_OUT} label="Opted-out" />
      <Tab value={UnitStatusFilters.INELIGIBLE} label="Ineligible" />
      <Tab value={UnitStatusFilters.SAFELEASE_PENDING_OPT_OUT} label="Pending opt-out" />
    </Tabs>
  );
}

export { StatusTabs };
